import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CHECKOUT_URL, openCheckout } from '../../utils/checkout';
const EASE = [0.23, 1, 0.32, 1] as const;
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-131" data-mp="39jukbs3krbeo">
      {visible && <motion.div initial={reduceMotion ? false : {
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={reduceMotion ? undefined : {
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.24,
      ease: EASE
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-gold/25 bg-ink/95 backdrop-blur" data-id="element-132" data-mp="39l5qtzoemx9h">
          <div className="mx-auto flex w-full max-w-5xl flex-wrap items-center justify-between gap-3 px-6 py-3" data-id="element-133" data-mp="3594ae2ogjm7c">
            <p className="text-sm text-sand" data-id="element-134" data-mp="309rnjhxl6f4r">
              <span className="font-semibold text-cream" data-id="element-135" data-mp="308ycw5vib5hc">Curly Seducción</span> ·{' '}
              <span className="line-through opacity-60" data-id="element-136" data-mp="2w97scjwkpll9">$27.00</span>{' '}
              <span className="font-semibold text-gold" data-id="element-137" data-mp="2rad0ksgmomp0">$6.39</span> pago único
            </p>
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={openCheckout} className="rounded-full bg-gold px-6 py-2.5 text-xs font-semibold uppercase tracking-[0.14em] text-ink transition-colors duration-150 ease-out hover:bg-gold-soft focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40" data-id="element-138" data-mp="3o03t4m5czzs6">
              Quiero el método
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}